import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import SplashScreen from "../screens/SplashScreen";
import AuthSplashScreen from "../screens/SplashScreen/AuthSplashScreen";
import MobileLoginScreen from "../screens/AuthPage/MobileLogin";
import EmailLoginScreen from "../screens/AuthPage/EmailLogin";
import MobileForgotPasswordScreen from "../screens/AuthPage/MobileForgotPassword";
import EmailForgotPasswordScreen from "../screens/AuthPage/EmailForgotPassword";
import Dashboard from "./dashboard";
import MobileResetPasswordScreen from "../screens/AuthPage/ResetMobilePassword";
import EmailResetPasswordScreen from "../screens/AuthPage/ResetEmailPassword";
import GoogleAdditionalInfo from "../screens/AuthPage/GoogleAdditionalInfo";
import EmailAdditionalInfo from "../screens/AuthPage/EmailAdditionalInfo";
import MobileAdditionalInfo from "../screens/AuthPage/MobileAdditionalInfo";
import TermsAndCondition from "../screens/TermsAndCondition/TermsAndCondition";
import Privacypolicy from "../screens/Privacypolicy/Privacypolicy";
import Careers from "../screens/Career/Career";
// import AboutUs from "../screens/AboutUs/AboutUs";
import PremiumMethod from "../screens/Dashboard/Premium/UpdatedPremiumMethod/PremiumMethod";
import PaymentMethod from "../screens/PaymentMethod/PaymentMethod";
import RefundPolicy from "../screens/RefundPolicy/RefundPolicy";
import ContactUs from "../screens/ContactUs/ContactUs";
import { getLocalStorage } from "../utils/function/localStorage";
import Referral from "../screens/Dashboard/Referral";
import Spinwheel from "../screens/Spinwheel";
import BuyReferralspinwheel from "../screens/BuyReferralspinwheel";
import ShareRedirect from "../components/Share";
import PrivacyPolicy2 from "../screens/SplashScreen/PrivacyPolicy2";
import TermsAndConditions2 from "../screens/SplashScreen/TermsCondition";
import PremiumRefundTC from "../screens/Dashboard/Premium/PremiumRefundTC/PremiumRefundTC";

const JoinRedirect = () => {
  const { username } = useParams();
  const token = getLocalStorage("tp_Aa_uth_access");
  return token ? <Navigate to="/home" /> : <Navigate to={`/authSplashScreen?sponsorId=${username}`} />;
};

const UserRedirect = () => {
  const { username } = useParams();
  const token = getLocalStorage("tp_Aa_uth_access");
  return token ? <Navigate to={`/home/social/profile/${username}`} /> : <Navigate to="/" />;
};

const UserApprovedPlatformsRedirect = () => {
  const { username } = useParams();
  const token = getLocalStorage("tp_Aa_uth_access");
  const target = username
    ? `/home/social/profile/${username}/approved-platforms`
    : `/home/social/profile/approved-platforms`;
  return token ? <Navigate to={target} /> : <Navigate to="/" />;
};

const PostRedirect = () => {
  const { postId } = useParams();
  const token = getLocalStorage("tp_Aa_uth_access");
  const formattedPostId = postId.startsWith("pid") ? postId : `pid${postId}`;
  return token ? <Navigate to={`/home/comments/${formattedPostId}`} /> : <Navigate to="/" />;
};

const TaskRedirect = () => {
  const { taskId } = useParams();
  const token = getLocalStorage("tp_Aa_uth_access");
  return token ? <Navigate to={`/home/task/details/${taskId}`} /> : <Navigate to="/" />;
};

const LeaderBoardRedirect = () => {
  const token = getLocalStorage("tp_Aa_uth_access");
  return token ? <Navigate to="/home/leader-board" /> : <Navigate to="/" />;
};

const TasksRedirect = () => {
  const token = getLocalStorage("tp_Aa_uth_access");
  return token ? <Navigate to="/home/task" /> : <Navigate to="/" />;
};

const QuizRedirect = () => {
  const token = getLocalStorage("tp_Aa_uth_access");
  return token ? <Navigate to="/home?target=quiz&modal=true" /> : <Navigate to="/" />;
};

const ScratchCardRedirect = () => {
  const token = getLocalStorage("tp_Aa_uth_access");
  return token ? <Navigate to="/home" /> : <Navigate to="/" />;
};

const BuyReferralRedirect = () => {
  const token = getLocalStorage("tp_Aa_uth_access");
  return token ? <Navigate to="/home/buyReferral" /> : <Navigate to="/" />;
};

const Routers = () => {

  const token = getLocalStorage("tp_Aa_uth_access");
  return (
    <>
      <Routes>
        <Route
          path="/*"
          index
          element={token ? <Navigate to="/home" /> : <SplashScreen />}
        />
        <Route path="/home/*" element={<Dashboard />} />
        <Route path="/authSplashScreen" element={<AuthSplashScreen />} />
        <Route path="/loginWithMobile" element={<MobileLoginScreen />} />
        <Route path="/loginWithEmail" element={<EmailLoginScreen />} />
        <Route
          path="/mobileResetPassword"
          element={<MobileResetPasswordScreen />}
        />
        <Route
          path="/Referral"
          element={<Referral />}
        />
        <Route
          path="/mobileForgotPassword"
          element={<MobileForgotPasswordScreen />}
        />
        <Route
          path="/emailForgotPassword"
          element={<EmailForgotPasswordScreen />}
        />
        <Route
          path="/emailResetPassword"
          element={<EmailResetPasswordScreen />}
        />
        <Route
          path="/googleAdditionalInfo"
          element={<GoogleAdditionalInfo />}
        />
        <Route path="/emailAdditionalInfo" element={<EmailAdditionalInfo />} />
        <Route
          path="/mobileAdditionalInfo"
          element={<MobileAdditionalInfo />}
        />


        <Route path="/terms-and-conditions" element={<TermsAndConditions2 />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy2 />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/spinwheel" element={<Spinwheel />} />
        {/* <Route path="/about-us" element={<AboutUs />} /> */}
        <Route path="/payment-method" element={<PaymentMethod />} />
        <Route path="/premium-refund-policy" element={<PremiumRefundTC />} />
        <Route path="/premiumPlus-refund-policy" element={<PremiumRefundTC />} />
        {/* <Route path="/payment-method" element={<PremiumMethod />} /> */}

        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/buy-referral-spin" element={<BuyReferralspinwheel />} />
        <Route path="/share" element={<ShareRedirect />} />
        <Route path="/join/:username" element={<JoinRedirect />} />
        <Route path="/user/:username" element={<UserRedirect />} />
        <Route path="/social/profile/:username" element={<UserRedirect />} />
        <Route path="/social/profile/:username/approved-platforms" element={<UserApprovedPlatformsRedirect />} />
        <Route path="/social/profile/approved-platforms" element={<UserApprovedPlatformsRedirect />} />
        <Route path="/post/:postId" element={<PostRedirect />} />
        <Route path="/social/:postId" element={<PostRedirect />} />
        <Route path="/task/:taskId" element={<TaskRedirect />} />
        <Route path="/socialMediaTask/:taskId" element={<TaskRedirect />} />
        <Route path="/leaderBoard" element={<LeaderBoardRedirect />} />
        <Route path="/leaderBoard/*" element={<LeaderBoardRedirect />} />
        <Route path="/tasks" element={<TasksRedirect />} />
        <Route path="/tasks/*" element={<TasksRedirect />} />
        <Route path="/quiz" element={<QuizRedirect />} />
        <Route path="/scratch-card" element={<ScratchCardRedirect />} />
        <Route path="/buyReferral" element={<BuyReferralRedirect />} />
      </Routes>
    </>
  );
};

export default Routers;
